import { HttpInterceptorFn } from '@angular/common/http';

const TRACEPARENT_HEADER = 'traceparent';
const TRACEPARENT_VERSION = '00';
const TRACE_FLAGS = '01';

export const traceContextInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.headers.has(TRACEPARENT_HEADER)) {
    return next(request);
  }

  const nextRequest = request.clone({
    setHeaders: {
      [TRACEPARENT_HEADER]: createTraceparent(),
    },
  });

  return next(nextRequest);
};

function createTraceparent(): string {
  const traceId = createNonZeroHex(32);
  const spanId = createNonZeroHex(16);
  return `${TRACEPARENT_VERSION}-${traceId}-${spanId}-${TRACE_FLAGS}`;
}

function createNonZeroHex(length: number): string {
  const random = createRandomHex(length);

  if (/[^0]/.test(random)) {
    return random;
  }

  return `${random.slice(0, length - 1)}1`;
}

function createRandomHex(length: number): string {
  const bytes = new Uint8Array(length / 2);
  fillRandomValues(bytes);

  return Array.from(bytes)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

function fillRandomValues(bytes: Uint8Array): void {
  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(bytes);
    return;
  }

  for (let index = 0; index < bytes.length; index += 1) {
    bytes[index] = Math.floor(Math.random() * 256);
  }
}
